'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CouponSearchModal = undefined;

var _CouponSearchModal2 = require('./CouponSearchModal');

var _CouponSearchModal3 = _interopRequireDefault(_CouponSearchModal2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CouponSearchModal = _CouponSearchModal3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/CouponSearchModal/index.js
// module id = 1763
// module chunks = 0